
import { Icon } from '@/lib/enum/Icon';
import ActionDialog from './ActionDialog.vue';

export default {
  name: 'ConfirmDeleteDialog',

  components: {
    ActionDialog,
  },

  props: {
    entity: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    headerLabel: {
      type: String,
      default: '',
    },
    primaryButtonLabel: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    iconColour: {
      type: String,
      default: 'red',
    },
  },

  emits: ['confirm', 'cancel', 'input', 'close'],

  data() {
    return {
      Icon,
    };
  },
  methods: {
    cancel() {
      this.$emit('cancel');
      this.$emit('close');
      this.$emit('input', false);
    },
    confirm() {
      this.$emit('confirm');
      this.$emit('close');
      this.$emit('input', false);
    },
  },
};
